// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/calc/result.scss';

// Packages
import Vue from 'vue';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';
import CalculationResult from '~scripts/components/EconomyCalculator/CalculationResult.vue';

//
// CUSTOMER CASES
//
import customerCasesInit from '~scripts/blocks/customer-cases';

customerCasesInit();

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

new Vue({
  el: '.js-result-banner',
  components: {
    CalculationResult,
  },
});

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
